/**
 * App entry: loads global styles and bootstraps the app (bootstrap + oauth SDK).
 */
import "./stylesheets/app.scss";
import("./bootstrap");
import("./utils/oauthSdk");
